import { gql } from '@apollo/client';

export const DELETE_CHAT_SESSION = gql`
  mutation DeleteChatSession($sessionId: ID!) {
    deleteChatSession(sessionId: $sessionId) {
      success
      errors
    }
  }
`;
